import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService} from '../../shared';
import {MembershipPeriodLineContainerModel} from '../../../../../../models/aggregates/crm/membership-suspension';
import {Core2Config} from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MembershipSuspensionAttachmentService extends BaseApiTemplateService<any> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-period-lines';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL +  Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-period-lines';
    this.endpoint_path =  Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-period-lines';
    this.httpClient = http;
  }

  addFilesWithDetails(formData: FormData, visa: ApiVisa) {
    let url = this.apiUrl + '/add-file/backoffice-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-file/backoffice-ep';
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  replaceFileWithDetails(formData: FormData, guid, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/backoffice-ep/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/replace-file/backoffice-ep/' + guid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  deleteFile(guid, visa: ApiVisa) {
    let url = this.apiUrl + '/remove-file/backoffice-ep/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/remove-file/backoffice-ep/' + guid;
    }
    return this.httpClient.put(url, "", this.getHttpHeader(visa));
  }

  getFile(guid, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/backoffice-ep/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/backoffice-ep/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

}


